import React, { Component } from "react"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import Link from "@material-ui/core/Link"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Redirect } from "react-router-dom"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      paper: {
            marginTop: theme.spacing(8),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
      },
      form: {
            width: "100%", // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            direction: "ltr",
      },
      label: {
            direction: "rtl",
            width: "100%", // Fix IE 11 issue.
      },
      submit: {
            margin: theme.spacing(3, 0, 2),
      },
})

class Login extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  pass: "",
                  mobile: "",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  temp: null,
            }
      }

      componentDidMount() {}

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangemobile = (event) => {
            this.setState({ mobile: event.target.value })
      }

      handleChangepass = (event) => {
            this.setState({ pass: event.target.value })
      }

      submit = (e) => {
            const { mobile, pass } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log("arr",arr)
                        if (arr.result === "ok") {
                              self.cookies.set("employee_gender", arr.data.employee_gender, { path: "/" })
                              self.cookies.set("employee_name", arr.data.employee_name, { path: "/" })
                              self.cookies.set("employee_family", arr.data.employee_family, { path: "/" })
                              self.cookies.set("employee_id", arr.data.employee_id, { path: "/" })
                              self.cookies.set("employee_image", arr.data.employee_image, { path: "/" })
                              self.cookies.set("employee_mobile", arr.data.employee_mobile, { path: "/" })
                              self.cookies.set("employee_token_str", arr.data.employee_token_str, { path: "/" })
                              // self.cookies.set("role_name", arr.data.role_name, { path: "/" })
                              self.cookies.remove("roles", { path: "/" })  // اول پاک کنه
                              self.cookies.set("roles", JSON.stringify(arr.data.roles), { path: "/" }) // بعد جدید بسازه

                              console.log("roles cookie just set:", self.cookies.get("roles"))

                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })

                              self.props.props.dispatch({
                                    type: "SETPROPEMPLOYEE",
                                    state: arr.data,
                              })
                              self.setState({ redirect: true })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "login_employee")
            fd.append("employee_mobile", mobile)
            fd.append("employee_pass", pass)
            fd.append("employee_token_app_version", "10101")
            fd.append("employee_token_mode", "webapp")
            fd.append("employee_token_device_name", "mozila")
            fd.append("employee_token_device_version", "4.2.2")
            fd.append("employee_token_ip", "192.168.1.1")
            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { snackMode, snackstr, mobile, pass, showSnack, redirect } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <div className={classes.paper}>
                                    <Avatar className={classes.avatar}>
                                          <LockOutlinedIcon />
                                    </Avatar>
                                    <Typography component="h1" variant="h5">
                                          ورود کارمندان
                                    </Typography>
                                    <form className={classes.form} noValidate>
                                          <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="mobile"
                                                label="شماره همراه"
                                                name="mobile"
                                                autoComplete="mobile"
                                                autoFocus
                                                value={mobile}
                                                onChange={this.handleChangemobile}
                                          />
                                          <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                name="password"
                                                label="رمز عبور"
                                                type="password"
                                                id="password"
                                                autoComplete="current-password"
                                                value={pass}
                                                onChange={this.handleChangepass}
                                          />
                                          <FormControlLabel
                                                align="right"
                                                className={classes.label}
                                                control={<Checkbox value="remember" color="primary" />}
                                                label="من را به خاطر پسپار"
                                          />

                                          <Button onClick={this.submit} fullWidth variant="contained" color="primary" className={classes.submit}>
                                                ورود
                                          </Button>
                                          <Grid container>
                                                <Grid item xs>
                                                      <Link href="#" variant="body2"></Link>
                                                </Grid>
                                                <Grid item>
                                                      <Link href="/forgetpass" variant="body2">
                                                            {"ارسال رمز به همراه در صورت فراموشی رمز"}
                                                      </Link>
                                                </Grid>
                                          </Grid>
                                    </form>
                              </div>
                              <Box mt={8}></Box>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                        </Container>
                  )
            }
      }
}

export default withStyles(styles)(Login)
